export default {
  backend: {
    apiBaseUrl: '%api-base-url-placeholder%',
    enigooTurnstileUrl: '%enigoo-turnstile-url-placeholder%',
  },
}
